import { actions as nextStop } from "./modules/next-stop"

const actions = {
  ...nextStop,
}

export default actions
